import React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import './Login.css'
import Cookies from 'js-cookie';
import {
    FaLock, 
    FaEnvelope,
    FaEye,
    FaEyeSlash,
    FaTimes
} from 'react-icons/fa'
import { BeatLoader } from 'react-spinners'
import API_BASE_URL from '../config/api'

const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false)
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('')
    const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false)
    const [forgotPasswordMessage, setForgotPasswordMessage] = useState('')
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError('')
        setLoading(true)
        
        try {
            const response = await axios.post(`${API_BASE_URL}/api/login/`, {
                email,
                password
            })
            
            // Save token to localStorage
            Cookies.set('token', response.data.access)
            Cookies.set('role', response.data.user.role)
            console.log(response.data)
            
            // Navigate based on user role
            const userRole = response.data.user?.role?.toLowerCase()
            
            switch (userRole) {
                case 'hr':
                    navigate('/hr/dashboard')
                    break
                case 'supervisor':
                    navigate('/hod/dashboard')
                    break
                case 'hod':
                    navigate('/hod/dashboard')
                    break
                case 'coo':
                    navigate('/coo/dashboard')
                    break
                case 'employee':
                    navigate('/employee/dashboard')
                    break
                default:
                    // Fallback to login if role is not recognized
                    navigate('/login')
                    break
            }
        } catch (err) {
            console.log(err)
            setError(err.response?.data?.non_field_errors[0] || 'An error occurred during login')
        } finally {
            setLoading(false)
        }
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const handleForgotPassword = async (e) => {
        e.preventDefault()
        setForgotPasswordMessage('')
        setForgotPasswordLoading(true)
        
        try {
            const response = await axios.post(`${API_BASE_URL}/api/forgot-password/`, {
                email: forgotPasswordEmail
            })
            
            setForgotPasswordMessage('Password reset instructions have been sent to your email.')
            setForgotPasswordEmail('')
            
            // Close modal after 3 seconds
            setTimeout(() => {
                setShowForgotPasswordModal(false)
                setForgotPasswordMessage('')
            }, 3000)
            
        } catch (err) {
            console.log(err)
            setForgotPasswordMessage(err.response?.data?.non_field_errors[0] || 'An error occurred. Please try again.')
        } finally {
            setForgotPasswordLoading(false)
        }
    }

    const openForgotPasswordModal = () => {
        setShowForgotPasswordModal(true)
        setForgotPasswordEmail('')
        setForgotPasswordMessage('')
    }

    const closeForgotPasswordModal = () => {
        setShowForgotPasswordModal(false)
        setForgotPasswordEmail('')
        setForgotPasswordMessage('')
    }

    return (
        <div className='login-page'>
            <div className='background-shapes'>
                <div className='shape shape-1'></div>
                <div className='shape shape-2'></div>
                <div className='shape shape-4'></div>
                <div className='shape shape-5'></div>
                <div className='shape shape-6'></div>
                <div className='shape shape-7'></div>
                <div className='shape shape-8'></div>
                <div className='shape shape-9'></div>


            </div>
            <div className='login-container'>
                <div className='logo-container'>
                    {/* Replace the src with your actual logo */}
                    <img 
                        src="/celebration logo.png" 
                        alt="Company Logo" 
                        className='company-logo'
                        onError={(e) => {
                            e.target.style.display = 'none'
                            document.querySelector('.logo-text').style.display = 'block'
                        }}
                    />
                    <h2 className='logo-text' style={{display: 'none'}}>PMS</h2>
                </div>
                <form onSubmit={handleSubmit} className='login-form'>
                    <h1 style={{color: '#fffb'}}>Welcome Back</h1>
                    
                    {error && <div className='error-message'>{error}</div>}
                    
                    <div style={{marginTop: '30px'}} className='form-group'>
                        <label htmlFor='email'>Email</label>
                        <div className='input-container'>
                            <i className='input-icon password-icon'><FaEnvelope/></i>
                            <input 
                                type="email" 
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder='Enter your email'
                                required 
                            />
                        </div>
                    </div>
                    
                    <div style={{marginTop: '30px'}} className='form-group'>
                        <label htmlFor='password'>Password</label>
                        <div className='input-container'>
                            <i className='input-icon password-icon'><FaLock/></i>
                            <input 
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder='Enter your password'
                                required 
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={togglePasswordVisibility}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#666',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>
                    
                    <div style={{marginTop: '25px', textAlign: 'right'}}>
                        <button
                            type="button"
                            onClick={openForgotPasswordModal}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#4F46E5',
                                cursor: 'pointer',
                                fontSize: '14px',
                                textDecoration: 'underline',
                                padding: '0'
                            }}
                        >
                            Forgot Password?
                        </button>
                    </div>
                    
                    <button 
                        type='submit' 
                        className='login-button'
                        disabled={loading}
                        style={{marginTop: '25px'}}
                    >
                        {loading ? (
                            <span className='button-text'><BeatLoader color="#fff" size={8} /></span>
                        ) : (
                            <span className='button-text'>Login</span>
                        )}
                    </button>
                </form>
            </div>
            
            {/* Forgot Password Modal */}
            {showForgotPasswordModal && (
                <div className="" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '12px',
                        width: '90%',
                        maxWidth: '400px',
                        position: 'relative',
                        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
                    }}>
                        <button
                            onClick={closeForgotPasswordModal}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                background: 'none',
                                border: 'none',
                                fontSize: '20px',
                                cursor: 'pointer',
                                color: '#666'
                            }}
                        >
                            <FaTimes />
                        </button>
                        
                        <h2 style={{ margin: '0 0 20px 0', color: '#333', fontSize: '24px' }}>
                            Forgot Password
                        </h2>
                        
                        <p style={{ margin: '0 0 20px 0', color: '#666', fontSize: '14px' }}>
                            Enter your email address and we'll send you instructions to reset your password.
                        </p>
                        
                        <form onSubmit={handleForgotPassword}>
                            <div className="form-group">
                                <label htmlFor="forgot-email">Email</label>
                                <div className="input-container">
                                    <i className="input-icon password-icon"><FaEnvelope /></i>
                                    <input
                                        type="email"
                                        id="forgot-email"
                                        value={forgotPasswordEmail}
                                        onChange={(e) => setForgotPasswordEmail(e.target.value)}
                                        placeholder="Enter your email"
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '12px 12px 12px 40px',
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            fontSize: '16px',
                                            outline: 'none',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </div>
                            </div>
                            
                            {forgotPasswordMessage && (
                                <div style={{
                                    margin: '15px 0',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    backgroundColor: forgotPasswordMessage.includes('error') || forgotPasswordMessage.includes('An error') ? '#fee' : '#efe',
                                    color: forgotPasswordMessage.includes('error') || forgotPasswordMessage.includes('An error') ? '#c33' : '#363',
                                    fontSize: '14px'
                                }}>
                                    {forgotPasswordMessage}
                                </div>
                            )}
                            
                            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                                <button
                                    type="button"
                                    onClick={closeForgotPasswordModal}
                                    style={{
                                        flex: 1,
                                        padding: '12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        backgroundColor: 'white',
                                        color: '#666',
                                        cursor: 'pointer',
                                        fontSize: '16px'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={forgotPasswordLoading}
                                    style={{
                                        flex: 1,
                                        padding: '12px',
                                        border: 'none',
                                        borderRadius: '8px',
                                        backgroundColor: '#4F46E5',
                                        color: 'white',
                                        cursor: forgotPasswordLoading ? 'not-allowed' : 'pointer',
                                        fontSize: '16px',
                                        opacity: forgotPasswordLoading ? 0.7 : 1
                                    }}
                                >
                                    {forgotPasswordLoading ? 'Sending...' : 'Send Instructions'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Login
